import { IS_PROD, VARIANT } from "../../config"

export const isScaVariant = () => {
    return VARIANT === "SCA";
}

export const isProd = () => {
    return IS_PROD === "true";
}

export const isSeoEnabled = () => {
    return !isScaVariant() && isProd();
}